import React, { FC } from "react";
import { Field, ErrorMessage, FieldProps } from "formik";
import { Input, InputProps, Popover } from "antd";
import Error from "../Error";
import "./inputField.scss";
import ReactivePasswordValidation from "../../../shared/components/ReactivePasswordValidation";

export interface IInputFieldProps extends InputProps {
  title?: string;
  type: string;
  name: string;
  placeholder?: string;
  disabled?: boolean;
  addonAfter?: any;
  addonBefore?: any;
  disablepaste?: boolean;
  className?: string;
  onChange?: (event: any) => void;
  enableReactivePasswordValidation?: boolean;
  showErrorMessage?: boolean;
}

const InputField: FC<IInputFieldProps> = ({ className, ...props }) => {
  const {
    name,
    title,
    disablepaste,
    onChange,
    enableReactivePasswordValidation,
    showErrorMessage,
  } = props;

  if (disablepaste) {
    props.disablepaste = props?.disablepaste?.toString() as unknown as boolean;
    props.onPaste = () => false;
    props.onDrop = () => false;
  }

  return (
    <div
      className={`input-field__wrapper ${className} ${
        props.addonBefore && "no-border-right"
      }`}
    >
      <label htmlFor={name}>{title}</label>
      <Field name={name}>
        {({ field }: FieldProps) => {
          const inputElement = (
            <Input
              {...field}
              {...props}
              {...(onChange ? { onChange: onChange } : null)}
              onPaste={() => false}
              style={{ marginTop: "0.5rem" }}
            />
          );

          return enableReactivePasswordValidation ? (
            <Popover
              placement="bottomLeft"
              content={<ReactivePasswordValidation value={field.value} />}
            >
              {inputElement}
            </Popover>
          ) : (
            inputElement
          );
        }}
      </Field>
      <div
        className={`error-message ${showErrorMessage ? "show-error-msg" : ""}`}
      >
        <ErrorMessage name={name}>
          {(message: string) => <Error message={message} />}
        </ErrorMessage>
      </div>
    </div>
  );
};

export default InputField;
